import React, { Component } from "react";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { withRouter } from "react-router";

import { HStack, Spacer, VStack, XText } from "IZOX/_X";
import { Accessor, GState, LocaleX, NavX } from "IZOX/STATIC";
import { SITEBASE } from "__SYSDefault/Domain";

class Denied extends Component {

  static propTypes = {
    redirect: PropsType.bool
  }

  static defaultProps = {
    redirect: false
  }

  componentDidMount(){
    this.setState((state, props) => ({
      ...props,
    }), () => {
      if(this.props.redirect){
        if(this.timeout) clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          console.error("[x] Denied :: Redirecting to Login");
          GState.setAutoLogin(false);
          NavX.Goto(this.props.history, "/Login");
        }, 3000);
      }
    });
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(Denied.defaultProps))){
      this.componentDidMount();
    }
  }

  componentWillUnmount() {
    if(this.timeout) clearTimeout(this.timeout);
    this.setState = (state, callback) => {
      return;
    };
  }

  render(){
    return (
      <VStack spacing={15} height="100%">
        <Spacer/>
        <HStack width="15vw">
          <img src={SITEBASE + "Images/denied.svg"} alt="not-found" style={{width: "100%"}}/> 
        </HStack>
        <XText style={{fontSize: 20, fontWeight: "bold"}}>
          {LocaleX.Parse({
            EN: "Access Denied",
            TC: "訪問被拒"
          })}
        </XText>
        <Spacer/>
      </VStack>
    );
  }

}

export default withRouter(Denied);
